export * from './gradeMatrixLive.service';
import { GradeMatrixLiveService } from './gradeMatrixLive.service';
export * from './gradeMatrixLive.serviceInterface';
export const APIS = [GradeMatrixLiveService];
